// extracted by mini-css-extract-plugin
export var deleteIcon = "_nj-5";
export var deleteOption = "_nj-3";
export var divider = "_nj-2";
export var downloadIcon = "_nj-4";
export var drawer = "_nj-0";
export var drawerFooter = "_nj-6";
export var drawerOpen = "_nj-1";
export var highlighted = "_nj-7";
export var lighterHighlight = "_nj-8";